const defaultErrorState = {
    hasError: false
}

export default (state = defaultErrorState, action) => {
  switch (action.type) {
    case 'FETCH_FAIL':
      return {
        hasError: true
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/error.js